var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelicopter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9.7,
    style: {
      fill: "#000"
    },
    width: 0.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M7.2,10.1c0.2,0,0.4,0,0.7,0c0.2,0,0.4,0,0.7,0c3.2,0.2,7.9,0.2,11.1,0c0.2,0,0.5,0,0.7,0c0.3,0,0.4,0,0.7,0 c2.6-0.3,2.6-0.6,0-0.9c-0.2,0-0.4,0-0.7,0s-0.4,0-0.7,0C16.5,9,11.8,9,8.5,9.2c-0.2,0-0.5,0-0.7,0c-0.3,0-0.4,0-0.7,0 C4.6,9.5,4.6,9.9,7.2,10.1z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 9.5,
    width: 0.5,
    height: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6,11.7V11c0-0.1,0-0.3-0.1-0.3h-2.6c-0.3,0-0.5,0.4-0.5,1H15.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3,8.7h0.4l1.7,2.4c0.2,0.2,0.4,0.4,0.6,0.4h10.8c0.3,0,0.4,0.3,0.4,0.7v0.8l-5.9-0.3l-6.1-0.3 c-0.2,0-0.4-0.2-0.5-0.6c0-0.1,0-0.1,0-0.2L2.3,8.7L2.3,8.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 10.6,
    style: {
      fill: "#000"
    },
    width: 0.5,
    height: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1,9.5c0,0.1,0,0.2,0,0.3s0,0.2,0,0.3c0.3,1.1,1.1,1.6,1.8,1.4c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2-0.1 c0.7-0.5,1-1.6,0.9-2.8c0-0.1,0-0.2,0-0.3s0-0.2,0-0.3C3.7,6.9,3,6.3,2.3,6.5c-0.1,0-0.1,0-0.2,0.1C2,6.6,2,6.7,1.9,6.7 C1.3,7.2,0.9,8.3,1,9.5z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9,13C9.9,13.1,9.9,13.1,9.9,13v0.2c0.2,0.9,0.6,1.6,1.1,2.1c0.2,0.2,0.5,0.4,0.7,0.5c0,0,0,0,0,0 c0.2,0,0.4,0.1,0.6,0.1h5.5h0c0-0.2,0-0.4,0-0.6c0-0.4-0.1-0.8-0.1-0.9h-0.6c-0.1,0-0.2-0.1-0.2-0.3v-0.4c0-0.2,0.1-0.3,0.2-0.3 h0.4l0.3-0.1v0l0,0l0,0c-0.4-0.6-0.8-1-1.3-1.1c0,0,0,0,0,0c0,0-0.1,0-0.2,0h-6c-0.1,0-0.3,0.1-0.4,0.3C10,12.7,9.9,12.8,9.9,13z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17,13.7v0.4c0,0.2,0.1,0.3,0.2,0.3h0.6c0,0,0.1,0.4,0.1,0.9c0,0.2,0,0.4,0,0.6c0,0,0,0,0,0 c0.2,0,0.4-0.2,0.4-0.4c0-0.1,0.1-0.1,0.1-0.2c0-0.2,0-0.4,0-0.7l-0.1-0.3c0,0,0-0.1,0-0.1c0,0,0,0,0,0l0,0l0,0l0,0 c-0.1-0.3-0.2-0.6-0.3-0.8v0l-0.3,0.1h-0.4C17.1,13.4,17,13.5,17,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.4,13.5c0-0.2,0.1-0.4,0.2-0.4H16c0.1,0,0.2,0.2,0.2,0.4v1.8c0,0.2-0.1,0.4-0.2,0.4h-0.4 c-0.1,0-0.2-0.2-0.2-0.4V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.8,17.4C11.8,17.5,11.8,17.5,11.8,17.4l4.8,0.1c0.3,0,0.6-0.3,0.7-0.7c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0 c-0.1,0.4-0.4,0.6-0.6,0.6h-0.3v-1.4h-0.1v1.4h-3.4v-1.4h-0.1v1.4L11.8,17.4C11.8,17.3,11.8,17.4,11.8,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M13,13.6c0-0.1,0-0.1,0.1-0.1h0.4c0,0,0.1,0,0.1,0.1v0.7c0,0.1,0,0.1-0.1,0.1h-0.4c0,0-0.1,0-0.1-0.1V13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M13.8,13.6c0-0.1,0-0.1,0.1-0.1h0.4c0,0,0.1,0,0.1,0.1v0.7c0,0.1,0,0.1-0.1,0.1h-0.4c0,0-0.1,0-0.1-0.1V13.6z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.7,13.6c0-0.1,0-0.1,0.1-0.1h0.4c0,0,0.1,0,0.1,0.1v0.7c0,0.1,0,0.1-0.1,0.1h-0.4c0,0-0.1,0-0.1-0.1V13.6z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M12.1,13.6c0-0.1,0-0.1,0.1-0.1h0.4c0,0,0.1,0,0.1,0.1v0.7c0,0.1,0,0.1-0.1,0.1h-0.4c0,0-0.1,0-0.1-0.1V13.6z "
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2,9.1L2.2,9.1L2.2,9.1c0.1,0.4,0.3,0.5,0.4,0.4h0c0,0,0,0,0,0C2.9,9.4,3,9.1,2.9,8.8v0v0 C2.8,8.5,2.7,8.3,2.5,8.4c0,0,0,0-0.1,0c0,0,0,0,0,0C2.2,8.5,2.1,8.8,2.2,9.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicopter);
export default __webpack_public_path__ + "static/media/helicopter.0063cbc8c8cf0ee5e6324a27f1e414b6.svg";
export { ForwardRef as ReactComponent };